import React, {Component} from 'react';
import APIFetcher from "../../API";

class NewPlacePage extends Component {

    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        let form = e.target;
        APIFetcher.createPlace(form.placeName.value)
            .then(response => {
                this.props.history.push("/places")
            })
            .catch(error => {
                alert(error);
            })
    }

    render() {
        return <div className="container-sm">
            <div className="p-3">
                <p className="text-center h2">Nouveau lieu</p>
                <form className="shadow-sm mb-5 bg-body rounded" onSubmit={this.handleSubmit}>
                    <ul className="list-group">
                        <li className="list-group-item">
                            <label htmlFor="eventTitle" className="form-label">Nom:</label>
                            <input type="text" id="eventTitle" name="placeName" className="form-control"/>
                        </li>
                        <li className="list-group-item text-center">
                            <button type="submit" className="btn btn-primary float-end">Créer</button>
                        </li>
                    </ul>
                </form>
            </div>
        </div>
    }
}

export default NewPlacePage;
